import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Portfolio() {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState(t('portfolio.filter.all'));

  const filters = [
    t('portfolio.filter.all'),
    t('portfolio.filter.tax'),
    t('portfolio.filter.business'),
    t('portfolio.filter.patronage')
  ];

  const projects = [
    {
      title: t('portfolio.project1.title'),
      description: t('portfolio.project1.desc'),
      category: t('portfolio.project1.category'),
      image: 'https://public.readdy.ai/ai/img_res/91bd748af701240f97520033ecb63281.jpg',
    },
    {
      title: t('portfolio.project2.title'),
      description: t('portfolio.project2.desc'),
      category: t('portfolio.project2.category'),
      image: 'https://readdy.ai/api/search-image?query=Agricultural%20cooperative%20business%20meeting%20with%20farmers%20and%20financial%20advisors%20reviewing%20patronage%20dividend%20documents%2C%20professional%20consultation%20setting%20with%20teal%20accents%2C%20collaborative%20atmosphere%2C%20rural%20business%20success%20theme&width=800&height=600&seq=portfolio-coop-002&orientation=landscape',
    },
    {
      title: t('portfolio.project3.title'),
      description: t('portfolio.project3.desc'),
      category: t('portfolio.project3.category'),
      image: 'https://readdy.ai/api/search-image?query=IRS%20audit%20resolution%20meeting%20with%20tax%20professional%20and%20client%20reviewing%20documents%2C%20professional%20office%20setting%20with%20teal%20color%20accents%2C%20confident%20business%20atmosphere%2C%20successful%20negotiation%20theme%2C%20organized%20paperwork&width=600&height=800&seq=portfolio-irs-003&orientation=portrait',
    },
    {
      title: t('portfolio.project4.title'),
      description: t('portfolio.project4.desc'),
      category: t('portfolio.project4.category'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20startup%20office%20with%20entrepreneurs%20working%20on%20laptops%20and%20financial%20planning%20charts%2C%20tech%20company%20growth%20visualization%20with%20teal%20and%20white%20colors%2C%20innovative%20business%20atmosphere%2C%20success%20and%20expansion%20theme&width=600&height=500&seq=portfolio-startup-004&orientation=landscape',
    },
    {
      title: t('portfolio.project5.title'),
      description: t('portfolio.project5.desc'),
      category: t('portfolio.project5.category'),
      image: 'https://readdy.ai/api/search-image?query=Credit%20union%20compliance%20office%20with%20financial%20systems%20and%20regulatory%20documents%2C%20professional%20banking%20environment%20with%20teal%20accents%2C%20organized%20compliance%20workflow%2C%20trust%20and%20security%20theme%2C%20modern%20financial%20institution&width=600&height=800&seq=portfolio-compliance-005&orientation=portrait',
    },
    {
      title: t('portfolio.project6.title'),
      description: t('portfolio.project6.desc'),
      category: t('portfolio.project6.category'),
      image: 'https://readdy.ai/api/search-image?query=Luxury%20estate%20planning%20consultation%20with%20wealth%20management%20documents%20and%20family%20legacy%20planning%20materials%2C%20sophisticated%20office%20setting%20with%20teal%20color%20scheme%2C%20high-end%20professional%20atmosphere%2C%20generational%20wealth%20theme&width=600&height=500&seq=portfolio-estate-006&orientation=landscape',
    }
  ];

  const filteredProjects = activeFilter === t('portfolio.filter.all')
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">{t('portfolio.title')}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('portfolio.subtitle')}
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                activeFilter === filter
                  ? 'bg-orange-500 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              </div>
              
              <div className="p-6">
                <div className="mb-3">
                  <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                    {project.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{project.description}</p>
                <button className="flex items-center gap-2 text-orange-500 font-semibold text-sm group-hover:gap-3 transition-all whitespace-nowrap">
                  {t('portfolio.cta')}
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
